export const BrandLogo = ({ className = "h-10" }) => {
  return (
    <div className={`inline-flex items-center ${className}`} aria-label="smartxglass">
      <img
        src="/brand/smartxglass-logo.png"
        alt="smartxglass"
        className="h-full w-auto object-contain logo-blink-x"
      />
    </div>
  );
};
